import { Component, computed, input, signal } from '@angular/core';

import { IAvatarPerson } from '../interfaces/avatar.interface';

@Component({
    standalone: false,
    selector: 'app-avatar',
    templateUrl: './avatar.component.html',
    host: { class: 'inline-flex shrink-0 overflow-hidden rounded-full' },
})
export class AvatarComponent {
    readonly person = input.required<IAvatarPerson>();

    protected readonly brokenProfileImageUrl = signal<string | null>(null);

    // Google may give no names, so they fall back to the email.
    protected readonly initials = computed(() => {
        const { firstName, lastName, email } = this.person();
        const initials = `${firstName.charAt(0)}${lastName.charAt(0)}`;
        return (initials || email.charAt(0)).toUpperCase();
    });
}
